"use client";

import type { Thing, WithContext } from "schema-dts";

type SchemaValue = Exclude<Thing, string>;

const HTML_SIGNIFICANT = /[<>&]/gu;

/** `\u` escapes are still valid JSON, and no string can close the tag. */
const HTML_SAFE_ESCAPES = new Map([
  ["<", String.raw`\u003c`],
  [">", String.raw`\u003e`],
  ["&", String.raw`\u0026`],
]);

interface SchemaProps<T extends Omit<SchemaValue, "@context">> {
  readonly value: T;
}

export const Schema = <T extends SchemaValue>({ value }: SchemaProps<T>) => {
  const json: WithContext<T> = {
    "@context": "https://schema.org",
    ...value,
  };

  const html = JSON.stringify(json).replaceAll(
    HTML_SIGNIFICANT,
    (char) => HTML_SAFE_ESCAPES.get(char) ?? char
  );

  return (
    <script
      type="application/ld+json"
      /* oxlint-disable-next-line react/no-danger -- JSON-LD structured data */
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};
